import { render } from "./CognitoLoginPasswordForgot.vue?vue&type=template&id=ebc141dc&scoped=true"
import script from "./CognitoLoginPasswordForgot.vue?vue&type=script&lang=js"
export * from "./CognitoLoginPasswordForgot.vue?vue&type=script&lang=js"

import "./CognitoLoginPasswordForgot.vue?vue&type=style&index=0&id=ebc141dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc141dc"]])

export default __exports__